
import portrait from './images/portrait-wide-tall.jpg';


export const threeColData = [
	{
		image: portrait,
		altText: 'Insert alt text.',
		eyebrow: 'ReactJS, Flutter, Google Charts API, HTML5 Canvas, Git, Sass, JavaScript, HTML, CSS, Python, C++, C, Wordpress, Drupal, Print & Web Design, Project Management, Public Engagment, WCAG 2.0 AA Accessibility',
		h3: 'Webmaster',
		h4: 'Programer | Artist | Collaborator',
		text: 'A decade of experience building websites, and collaborating with stakeholders to improve performance, design, and user experience.  Utilizing advanced degrees in computer science, fine art, and sociology for my work at the Metropolitan Museum of Art and Smithsonian Institution.',
		link1: 'https://github.com/lapank',
		link2: 'https://www.linkedin.com/in/kaylin-lapan-9a55749b/',
	},

]